import { Drawing } from "./index";

export interface Coordinates {
  x: number;
  y: number;
}

export function toCoords(row: number, col: number): Coordinates {
  let x = col - Drawing.side / 2;
  let y = -(row - Drawing.side / 2);
  if (x >= 0) x += 1;
  if (y <= 0) y -= 1;
  return { x, y };
}

export function toIdx(coords: Coordinates): number | null {
  const limit = Drawing.side / 2;
  if (
    coords.x === 0 ||
    coords.y === 0 ||
    coords.x < -limit ||
    coords.x > limit ||
    coords.y < -limit ||
    coords.y > limit
  ) {
    return null;
  }
  let row = -(coords.y - Drawing.side / 2);
  let col = coords.x + Drawing.side / 2;
  if (row > Drawing.side / 2) row -= 1;
  if (col > Drawing.side / 2) col -= 1;
  return row * Drawing.side + col;
}
